export default [
    {
        path: '/picture',
        name: 'picture',
        meta: {
            title: '自动抢案源'
        },
        component: () => import('@/views/picture/index.vue')
    }
]
